<template>  
  <div>
    <div class="row">
      <div class="col-md-12" v-if="!notaCarregada">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="card-title f-20-mobile">Notas de Compra do dia {{data_inicio_cabecalho}} à {{data_fim_cabecalho}}</h4>
          </div>
          
          <div class="row">            
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" v-model="data_inicio">
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" v-model="data_fim">
            <button class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile btn-primary" style="height: 30px; margin-left: 20px; padding: 0px; margin-top: 0px;" id="filtrar" @click="filtrar"> Filtrar</button>
          </div>

          <div class="mb-3">
            <div v-for="nota of notas" class="row py-3 px-2 bordered-block-table only-mobile">
              <div class="col-6">      
                <span style="color: #888;">{{ nota.dhEmi | moment("DD/MM/YYYY HH:mm") }}</span>
                <br>
                <strong>Nº Nota {{ nota.nNF }}</strong>
                <br>
              </div>
              <div class="col-6 text-right">
                Valor<br>
                <strong>{{ nota.vNF.toFixed(2) | currencyBrl(true) }}</strong>
              </div>
              <div class="col-12">
                {{ nota.xNome }}
              </div>
            </div>
          </div>
          <a :href="notasHref" target="_blank" class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile btn-primary">Baixar XMLs</a>
          <table class="display responsive nowrap table table-hover table-striped table-bordered hidden-mobile">
            <thead>
              <tr>
                <th class="">Fornecedor</th>
                <th>Dt. Emissão</th>
                <th>Série</th>
                <th>N. Nota</th>
                <th class="text-right">Valor</th>
                <th class="text-center">Importar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="obj of notas">
                <td>{{ obj.xNome }}</td>
              <td>{{ new Date(obj.dhEmi).toLocaleDateString('pt-BR',{minute:"2-digit",hour:"2-digit"})  }}
              </td>
              <td>{{ obj.serie }}</td>
              <td>{{ obj.nNF }}</td>
              <td class="text-right">{{ obj.vNF.toFixed(2) | currencyBrl(true) }}</td>
              <td class="text-right">
                <template v-if="obj.status == 0">
                  <button v-if="cadastroWeb" @click="iniciar(obj)" type="button" class="btn btn-sm btn-info btn-round px-2 py-1" title="Importar"><i class="fa fa-download"></i></button>
                  <button v-if="cadastroWeb" @click="removerNotaCompra(obj)" type="button" class="btn btn-sm btn-danger btn-round px-2 py-1 ml-3" title="Remover"><i class="fa fa-close"></i></button>
                </template>

                <button v-if="obj.status == 1" @click="handleNotaImportada(obj)" title="Nota importada!" type="button" class="btn btn-sm btn-success btn-round px-2 py-1 ml-3 text-center" style="width: 26px; height: 26px; position: relative;">
                  <i class="fa fa-check" style="position: absolute; top:6px; left: 6px"></i>
                </button>
                
                <button v-if="obj.status == 2" @click="handleNotaCancelada(obj)" title="Nota removida!" type="button" class="btn btn-sm btn-secondary btn-round px-2 py-1 ml-3 text-center" style="width: 26px; height: 26px; position: relative;">
                  <i class="fa fa-close"></i>
                </button>
              </td>
              </tr>
              <tr v-if="!notas || !notas.length">
                <td class="text-center" colspan="9">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
          </table>
        </card>
      </div>
    </div>

    <entrada-component ref="entradaComponent" @onCancelled="onCancelled" @onComplete="onComplete"></entrada-component>
  </div>
</template>

<script>

import axios from 'axios'

import { Card } from 'src/components'
import moment from 'moment'
import FiscalService from '@/services/FiscalService.js'
import ProdutoService from '@/services/ProdutoService.js'
import EntradaComponent from '@/pages/Fiscal/EntradaComponent'
import CategoriaFiscalService from '@/services/CategoriaFiscalService.js'
import ErrorService from '@/services/ErrorService.js'


export default {
  components: {
    Card,
    EntradaComponent
  },
  data() {
    return {
      data_inicio: moment().format("YYYY-MM-DD"),
      data_fim: moment().format("YYYY-MM-DD"),
      data_fim_cabecalho:moment().format("DD/MM/YYYY"),
      data_inicio_cabecalho:moment().format("DD/MM/YYYY"),
      loja:null,
      notasHref:'',
      cadastroWeb: localStorage.getItem('config_modulo_cadastro_web') == "true" ? true : false,
      lojas:[],
      notas: [],
      notas_url: '',
      categorias: [],
      produtos:[],
      file: null,
      base64: null,
      notaCarregada: false,
      status: 'null',
      moduloCategoriaFiscal: localStorage.getItem('config_modulo_categoria_fiscal') == "true" ? true : false,
    }
  },
  methods:{
    handleNotaImportada(obj) {
      this.$swal.fire({
        title: 'Nota importada',
        text: 'Essa nota já foi importada!',
        type: 'success',
        confirmButtonText: 'Sim',
        showCancelButton: false
      }).then(result => {
        //
      })
    },
    handleNotaCancelada(obj) {
      this.$swal.fire({
        title: 'Nota cancelada',
        text: 'Essa nota foi cancelada!',
        type: 'error',
        confirmButtonText: 'Sim',
        showCancelButton: false
      }).then(result => {
        //
      })
    },
    removerNotaCompra(obj) {
      this.$swal.fire({
        title: 'Remover Nota',
        text: 'Tem certeza que deseja remover essa nota? Essa ação é irreversível',
        type: 'warning',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        showCancelButton: true
      }).then(result =>{
        if(result.value){
          let data = JSON.stringify({
            "cnpj": this.loja.cnpj, 
            "chNFe": obj.chNFe,
            "docZip": false,
            "key": localStorage.getItem('config_key_robo'),
            "status": 2
          });

          axios.post('https://tomcat.yooga.com.br/RoboServlet/Notas', data).then(res => {
            this.loadNotas();
            
            this.$swal.fire({
              text: 'Nota cancelada com sucesso',
              type: 'success'
            })
          })
          .catch(err => {
            this.$swal({
              text: error,
              type: "error",
            });
          });

          this.loadNotas()
        }
      })
    },
    filtrar() {
      this.data_fim_cabecalho = moment(this.data_fim).format('DD/MM/YYYY');
      this.data_inicio_cabecalho = moment(this.data_inicio).format('DD/MM/YYYY');
      this.loadNotas();
    },
    onComplete(xml) {
      if(xml) {
        let data = JSON.stringify({"cnpj": this.loja.cnpj, 
          "chNFe": xml.protNFe.infProt.chNFe,
          "docZip": false,
          "key": localStorage.getItem('config_key_robo'),
          "status": 1});

        axios.post('https://tomcat.yooga.com.br/RoboServlet/Notas', data).then(res => {
          this.loadNotas();
        })
        .catch(err => {
          ErrorService.getMessage(err.response)
          // this.$swal({
          //   text: error,
          //   type: "error",
          // });
        });
      }      
    },
    onCancelled(data) {
      this.notaCarregada = false;
    },
    iniciar(nota) {
      let data = JSON.stringify({
        "chNFe": nota.chNFe,
        "cnpj": this.loja.cnpj, 
        "docZip": true,
        "key": localStorage.getItem('config_key_robo'),
        "status": 0
      });

      axios.post('https://tomcat.yooga.com.br/RoboServlet/Notas', data)
      .then(res => {
        if(res.data.NFe[0].docZip == null || res.data .NFe[0].docZip.length == 0){
          swal.fire({text:"Selecione um XML para iniciar o processo", 
            type: "warning",
          });
        } else {
          const xmlparser = require('xml2js').parseString;
          
          try{
            var data = atob(res.data.NFe[0].docZip).toString()
            if (data.charCodeAt(0) == 239 && data.charCodeAt(1) == 187 && data.charCodeAt(2) == 191) {
              data = data.substr(3);
            }

            FiscalService.CarregarCompra({ xml: data }).then(ret => {
              if(ret != null && ret.data.NFe.infNFe != null){
                let nfe = null;

                nfe = ret.data.NFe.infNFe;
                nfe.protNFe = {};
                nfe.protNFe = ret.data.protNFe;

                this.notaCarregada = true;
                this.$refs.entradaComponent.setNota(nfe)
              }else{
                this.$swal({
                  text: 'XML Inválido, tente novamente',
                  type: "warning",
                  confirmButtonText:'Entendo'
                });
              }
            }).catch(error =>{
              console.error(error)
              ErrorService.getMessage(err.response)
              // this.$swal({text:error.response.data,
              //   type: "warning",
              // });
            });

            this.$refs.entradaComponent.setNota(xml)
            // this.notaCarregada = true
          }catch (ex){
            console.log(ex);
          }
        }
      })
    },
    loadNotas() {
      let data = JSON.stringify({
        "cnpj": this.loja.cnpj, 
        "data_ini": this.data_inicio,
        "data_fim": this.data_fim,
        "docZip": false,
        "key": localStorage.getItem('config_key_robo'),
        "status": -1
      });

      axios.post('https://tomcat.yooga.com.br/RoboServlet/Notas', data)
      .then(response => { 
        this.notas = response.data.NFe;
        this.loja.cnpj = this.loja.cnpj.replace("/","").replace(".","").replace("-","");
        let params = '?cnpj='+this.loja.cnpj+'&key='+localStorage.getItem('config_key_robo')+'&data_ini='+this.data_inicio+'&data_fim='+this.data_fim
        this.notasHref = 'https://tomcat.yooga.com.br/RoboServlet/Download'+params;
      })
      .catch(function (error) {
        console.log(error);
        ErrorService.getMessage(err.response)
      });
    },
  },
  mounted() {
    let stores;  
    try{
      stores = JSON.parse(localStorage.getItem('stores'));
      this.loja = stores.find(element => element.idi == localStorage.getItem('current_idi'));
    }catch(err){
      console.error(err);
    }

    this.loadNotas();
  }
}
</script>

<style>
</style>